import { errorMessages } from 'commons/messages'
import { CustomBoolean, TypesValidations } from 'constants/enums'
import { applyIntegerOrFloatPositiveNumberMask } from './mask'

const trim = (text: string) => text.trim()

const removeSpecialCharacters = (text: string) =>
  text.replace(/[^\w\s]/gi, '').replace('_', '')

const trimTextOnlySpaces = (text: string) => {
  let newValue = text
  if (!text.replace(/\s/g, '').length) {
    newValue = trim(text)
  }
  return newValue
}

const removeLetters = (value: string) => value.replace(/\D+/g, '')

const removeNoDigits = (value: string) => {
  let newValue = removeSpecialCharacters(value)
  newValue = removeLetters(newValue)
  return newValue
}

const toFirsLetterUpper = (word: string) => {
  return word
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match: string, index: number) {
      if (/\s+/.test(match)) return ' '
      return index === 0 ? match.toUpperCase() : match.toLowerCase()
    })
}

const toAllFirstLetterUpper = (str: string) => {
  let phrase = ''
  const words = str.toLowerCase().split(' ')
  words.forEach((word: string, index: number) =>
    index === words.length - 1
      ? (phrase = phrase + toFirsLetterUpper(word))
      : (phrase = phrase + toFirsLetterUpper(word) + ' ')
  )
  return phrase
}

const getValueDiscount = (value: string) => {
  return parseInt(value.replace(/^[a-z0]{1,100}$/, ''))
}

const convertBooleanApiValue = (value: CustomBoolean) => {
  return value === TypesValidations.YES
}

const errorMessagesValidation = (value: string, minumumValue?: number) => {
  const requiredFiledValidation = value.length <= 0 ? errorMessages.emptyField : ''
  const minumumValueValidation =
    value.length <= 0
      ? errorMessages.emptyField
      : value.length >= (minumumValue || 4)
      ? ''
      : errorMessages.invalidField
  return minumumValue ? minumumValueValidation : requiredFiledValidation
}

const verifyDiscount = (value: string): number => {
  let newValue = value.replace('.', ',')
  newValue =
    newValue.toString() === '0'
      ? applyIntegerOrFloatPositiveNumberMask(newValue?.replace('0', ''))
      : applyIntegerOrFloatPositiveNumberMask(newValue)

  let valueDiscount = parseFloat(newValue?.replace(',', '.'))

  if (isNaN(valueDiscount) || !valueDiscount.toString().length) {
    valueDiscount = 0
  } else if (valueDiscount > 99.99) {
    valueDiscount = 99.99
  }

  return valueDiscount
}

function isValidNumber(value: string) {
  return /^-?\d+$/.test(value)
}

const isValidDecimalString = (value: string): boolean => /^\d+(,|\.)?\d*$/.test(value)
const decimalStringToNumber = (value: string): number => Number(value.replace(',', '.'))

const formatNumber = (value: string) => value.replace(/[^\d.,]+/g, '')
const truncateString = (str: string, num: number) => {
  let format = ''
  if (!str) {
    return str
  }
  if (Array.isArray(str)) {
    format = str.join(' ')
  } else {
    format = str
  }
  if (format?.length <= num) {
    return format
  }
  return `${format.slice(0, num)}...`
}
const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

const isValidDomainEmail = (email: string): boolean => {
  const regex = /^[^\s@]+@(?!alpargatas\.|ioasys\.)[^\s@]+\.[^\s@]+$/

  return regex.test(email)
}

const removeDiacritics = (text: string): string => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const removeDiacriticsAndSpecialCharacters = (text: string): string => {
  return removeSpecialCharacters(removeDiacritics(text))
}

const formatCnpj = (cnpj: string): string => {
  if (!cnpj) return ''

  const rawCnpj = removeNoDigits(cnpj)
  return rawCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export {
  trim,
  removeSpecialCharacters,
  removeLetters,
  removeNoDigits,
  trimTextOnlySpaces,
  toAllFirstLetterUpper,
  toFirsLetterUpper,
  getValueDiscount,
  convertBooleanApiValue,
  errorMessagesValidation,
  verifyDiscount,
  formatNumber,
  truncateString,
  isValidNumber,
  isValidDecimalString,
  decimalStringToNumber,
  toTitleCase,
  isValidDomainEmail,
  removeDiacritics,
  removeDiacriticsAndSpecialCharacters,
  formatCnpj
}
